"use client"
import { Box } from "@chakra-ui/react/box"
import { Grid } from "@chakra-ui/react/grid"
import { VStack } from "@chakra-ui/react/stack"

import MySkillsCard from "@/components/MySkillsCard"
import MySkillsCardTitle from "@/components/MySkillsCardTitle"
import SectionTitle from "@/components/SectionTitle"
import siteConfig from "@/config/siteConfig"
import { Skill } from "@/types/database"

/**
 * Renders the component
 *
 * @return {JSX} Component's markup
 */
const MySkills: React.FC<{ data: Skill[] }> = ({ data }) => {
  const developmentSkills = data.filter((skill) => "development" === skill.area)
  const designSkills = data.filter(
    (skill) =>
      "design" === skill.area || "design_and_development" === skill.area
  )

  return (
    <Box
      alignItems="stretch"
      as="section"
      flexWrap="nowrap"
      justifyContent="flex-start"
      marginBottom={6}
      overflow="visible"
      position="relative"
      rounded={"2xl"}
      zIndex={1}
    >
      <SectionTitle line noPadding preface="My Skills" />
      <VStack gap={2}>
        <Grid
          gap=".6rem"
          gridAutoRows={"1fr"}
          gridTemplateColumns={[
            "repeat(auto-fill, minmax(124px, 1fr))",
            "repeat(auto-fill, minmax(124px, 1fr))",
            "repeat(auto-fill, minmax(124px, 1fr))",
            "repeat(auto-fill, minmax(124px, 1fr))",
          ]}
          width="100%"
        >
          <MySkillsCardTitle
            title="in Product Design"
            years={siteConfig.yearsDesign}
          />
          {designSkills.map((skill) => {
            // console.log(skill);
            return <MySkillsCard key={skill.id} skill={skill} />
          })}
        </Grid>
        <Grid
          gap=".6rem"
          gridAutoRows={"1fr"}
          gridTemplateColumns={[
            "repeat(auto-fill, minmax(124px, 1fr))",
            "repeat(auto-fill, minmax(124px, 1fr))",
            "repeat(auto-fill, minmax(124px, 1fr))",
            "repeat(auto-fill, minmax(124px, 1fr))",
          ]}
          width="100%"
        >
          <MySkillsCardTitle
            title="in UI Development"
            years={siteConfig.yearsDevelopment}
          />

          {developmentSkills.map((skill) => (
            <MySkillsCard key={skill.id} skill={skill} />
          ))}
        </Grid>
      </VStack>
    </Box>
  )
}

export default MySkills
